function init() {

  let fragment = document.createDocumentFragment();

  const sticky_footer = document.getElementById('c-footer-sticky');
  const footer_bottom = document.getElementById('c-footer__bottom');
  const footer_top = document.getElementById('c-footer__top');
  const social_links = document.getElementById('c-nav-social-footer');

  if (!sticky_footer) {
    return;
  }

  fragment.appendChild(social_links);
  footer_bottom.appendChild(fragment);

}

export default init;
